import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_container = _resolveComponent("el-container")!
  const _component_LogsPageFilters = _resolveComponent("LogsPageFilters")!
  const _component_LogsPageParameterRow = _resolveComponent("LogsPageParameterRow")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_TwoFactorAuthDialog = _resolveComponent("TwoFactorAuthDialog")!
  const _component_LogsPageDifferenceDialog = _resolveComponent("LogsPageDifferenceDialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_container, { class: "logs-page__header" }, {
      default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
        _createElementVNode("h2", null, "Logs", -1 /* CACHED */)
      ]))]),
      _: 1 /* STABLE */
    }),
    (_ctx.isLogsFiltersAllowed)
      ? (_openBlock(), _createBlock(_component_LogsPageFilters, { key: 0 }))
      : _createCommentVNode("v-if", true),
    _createVNode(_component_el_container, { class: "logs-page__content" }, {
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          size: "small",
          class: "logs-page__table",
          "tooltip-effect": "light",
          data: _ctx.logList,
          border: ""
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.logsListColumns, (column) => {
              return (_openBlock(), _createBlock(_component_el_table_column, {
                key: column.value,
                prop: column.value,
                label: column.label,
                "min-width": column.width,
                align: column.align
              }, {
                default: _withCtx(({ row }) => [
                  (_ctx.isNeedShowList(column.value))
                    ? (_openBlock(), _createBlock(_component_LogsPageParameterRow, {
                        key: 0,
                        "logs-parameter-row": row[column.value],
                        onClickParameterRow: ($event: any) => (_ctx.onShowDifference(row))
                      }, null, 8 /* PROPS */, ["logs-parameter-row", "onClickParameterRow"]))
                    : _createCommentVNode("v-if", true)
                ]),
                _: 2 /* DYNAMIC */
              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["prop", "label", "min-width", "align"]))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["data"])), [
          [_directive_loading, _ctx.isLogsListLoading]
        ]),
        (_ctx.logList.length)
          ? (_openBlock(), _createBlock(_component_el_pagination, {
              key: 0,
              "current-page": _ctx.currentPage,
              "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentPage) = $event)),
              "page-size": _ctx.limit,
              "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.limit) = $event)),
              class: "logs-page__pagination",
              "page-sizes": _ctx.paginationProperties.pageSizes,
              total: _ctx.totalPages,
              layout: _ctx.paginationProperties.layout,
              small: "",
              onSizeChange: _ctx.handleSizeChange,
              onCurrentChange: _ctx.handleCurrentChange
            }, null, 8 /* PROPS */, ["current-page", "page-size", "page-sizes", "total", "layout", "onSizeChange", "onCurrentChange"]))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }),
    _createVNode(_component_TwoFactorAuthDialog, { action: _ctx.getLogListReport }, null, 8 /* PROPS */, ["action"]),
    _createVNode(_component_LogsPageDifferenceDialog, {
      modelValue: _ctx.isDialogVisible,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isDialogVisible) = $event)),
      "parameter-item": _ctx.selectedParameterItem
    }, null, 8 /* PROPS */, ["modelValue", "parameter-item"])
  ], 64 /* STABLE_FRAGMENT */))
}